import { connect } from 'react-redux';

import ShareProposal from '../../components/ShareProposal';
import { StoreState } from '../../reducers';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { config },
		routerParamsHistory,
		driveList,
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];

	return {
		clientId: config.clientId,
		driveItem: driveList.driveItems[+resourceId],
	};
};

export default connect(mapStateToProps)(ShareProposal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ShareProposal/index.tsx